import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ProductFacet, ProductSort } from '@kion/data-models';
// tslint:disable-next-line:nx-enforce-module-boundaries
import { Checkbox } from '../../../../../../shared/ui/src/lib/shared/elements/checkbox/checkbox.component';

@Component({
  selector: 'kion-filter-bar',
  templateUrl: './filter-bar.component.html',
  styleUrls: ['./filter-bar.component.scss']
})
export class FilterBarComponent implements OnInit {

  @Input() totalResults: number;
  @Input() filter: ProductFacet[];

  filterVisible: boolean;

  // tslint:disable-next-line:no-output-rename
  @Output('removeFilter') removeFilterEmitter: EventEmitter<string> = new EventEmitter<string>();
  // tslint:disable-next-line:no-output-rename
  @Output('addFilter') addFilterEmitter: EventEmitter<string> = new EventEmitter<string>();
  // tslint:disable-next-line:no-output-rename
  @Output('filterToggled') filterToggleEmitter: EventEmitter<void> = new EventEmitter<void>();
  // tslint:disable-next-line:no-output-rename
  @Output('removeAllFilter') removeAllFilterEmitter: EventEmitter<void> = new EventEmitter<void>();

  constructor() { }

  ngOnInit(): void {
    this.filterVisible = true;
  }

  boxToggled(box: Checkbox) {
    if (box.checked) {
      this.addFilterEmitter.emit(box.query);
      return;
    }
    this.removeFilterEmitter.emit(box.query);
  }

  filterToggledClicked() {
    this.filterVisible = !this.filterVisible;
    this.filterToggleEmitter.emit();
  }

  deleteAllFilter() {
    this.removeAllFilterEmitter.emit();
  }

  removeFilter(query: string) {
    this.removeFilterEmitter.emit(query);
  }
}
